import { render, staticRenderFns } from "./ShopCategoryTree.vue?vue&type=template&id=08098c69&scoped=true"
import script from "./ShopCategoryTree.vue?vue&type=script&lang=js"
export * from "./ShopCategoryTree.vue?vue&type=script&lang=js"
import style0 from "./ShopCategoryTree.vue?vue&type=style&index=0&id=08098c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08098c69",
  null
  
)

export default component.exports